<template>
  <!-- TODO: Responsive sizing -->
  <div style="height: 500px; width: 100%">
    <l-map :center="center" :zoom="zoom" :options="mapOptions" ref="lmap">
    </l-map>
  </div>
</template>

<script>
import { LMap } from 'vue2-leaflet'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-loading'
import 'leaflet-loading/src/Control.Loading.css'

export default {
  name: 'GenericMap',
  components: {
    LMap
  },
  props: {
    centerPopups: { type: Boolean, default: false }
  },
  data () {
    return {
      zoom: 7.45,
      center: L.latLng(51, -1.377), // Initial position over southern UK
      mapOptions: {
        zoomSnap: 0.5
      }
    }
  },
  methods: {
    /**
     * Getter for Vue 2 Leaflet internal map object
     *
     * @returns {*} Leaflet map object
     */
    getMap () {
      return this.$refs.lmap.mapObject
    },
    /**
     * Getter for the tileset layer control
     *
     * @returns {*} Leaflet layer control
     */
    getLayerControl () {
      return this.layerControl
    },
    /**
     * Helper function for flying to a point on the map
     *
     * @param {Number} latitude
     * @param {Number} longitude
     * @param {Number} zoom
     */
    moveToCoords (latitude, longitude, zoom) {
      this.getMap().flyTo(new L.LatLng(latitude, longitude), zoom)
    },
    /**
     * Helper function for fitting the map to specified bounds
     *
     * @param {Number[][]} bounds Leaflet bounds, a list of latitude longitude pairs
     */
    fitToBounds (bounds) {
      this.getMap().fitBounds(bounds, { padding: [100, 100] })
    },
    /**
     * Perform initial setup for the Leaflet map object
     *
     * @param {*} map Leaflet map object
     */
    mapInit (map) {
      // Enable loading control (shows spinner when tiles are loading)
      const loadingControl = L.Control.loading({
        separate: true
      })
      map.addControl(loadingControl)

      if (this.centerPopups) {
        // Move popups to the middle of the map's viewport
        map.on('popupopen', e => {
          const px = map.project(e.target._popup._latlng) // Find the pixel location on the map where the popup anchor is
          px.y -= e.target._popup._container.clientHeight / 2 // Find the height of the popup container, divide by 2, subtract from the Y axis of marker location
          map.panTo(map.unproject(px), { animate: true }) // Pan to new center
        })
      }
    },
    /**
     * Add Google and OSM tilesets to a map and return a layer control for them
     *
     * @param {*} map Leaflet map object
     *
     * @returns {*} Leaflet layer controls
     */
    tilesetInit (map) {
      // TODO: Add correct atrribution to Google sources

      const cartoLightOsm = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
        maxZoom: 19.5,
        subdomains: ['a', 'b', 'c'],
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attribution">CARTO</a>'
      })

      const googleSatellite = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
        maxZoom: 19.5,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution:
        '&copy; Google'
      })

      const googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        maxZoom: 19.5,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution:
        '&copy; Google'
      })

      const googleStreet = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        maxZoom: 19.5,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        attribution:
        '&copy; Google'
      })

      const osm = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19.5,
        subdomains: ['a', 'b', 'c'],
        attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      })

      cartoLightOsm.addTo(map)

      const baseMaps = {
        'Carto Light OSM': cartoLightOsm,
        'OpenStreetMap': osm,
        'Google Satellite': googleSatellite,
        'Google Hybrid': googleHybrid,
        'Google Street': googleStreet
      }

      const layerControl = L.control.layers(baseMaps)
      layerControl.addTo(map)
      return layerControl
    }
  },
  mounted () {
    // Wait until next tick so map will be initialised
    this.$nextTick(() => {
      const map = this.getMap()

      this.mapInit(map)

      // Add OSM and Google tilesets
      this.layerControl = this.tilesetInit(map)
    })
  }
}
</script>
<style>
  /* Prevent map showing over sidebar */
.vue2leaflet-map{
  z-index: 0;
}
</style>
